import { createMaterial, createParalellepiped } from './utils'
import state from '../state'
import * as THREE from 'three'
import textureUrls from '../textures/urls'

export default function createWall({
  height,
  pos,
  quat,
  textureUrl,
  width = 1,
  x,
  xo = 0,
  z,
  zo = 0,
} = {}) {
  const brickLength = state.objects.wall.brick.length
  const brickDepth = state.objects.wall.brick.depth
  const brickHeight = brickLength
  const brickMass = state.objects.wall.brick.mass

  const texture =
    // new THREE.TextureLoader().load(textureUrl) ||
    new THREE.TextureLoader().load(state.game.textureUrl)
  const x0 = -width * brickLength + (x || 0)

  pos.set(z, brickHeight, x0)
  quat.set(0, 0, 0, 1)

  for (let j = 0; j < height; j++) {
    pos.z = x0 + zo
    //console.log('pos', pos)
    const brick = createParalellepiped(
      brickDepth,
      brickHeight,
      brickLength,
      brickMass,
      pos,
      quat,
      //createMaterial(),
      new THREE.MeshPhongMaterial({ map: texture }),
    )
    brick.castShadow = true
    brick.name = 'brick'
    brick.receiveShadow = true
    //console.log('brick.position', brick.position)
    //pos.z += brickLength + 1
    // for (let i = 0; i < width; i++) {}

    pos.y += brickHeight
  }
}
